<template>
  <div>
    <div class="mb-6">
      <a
        class="text-decoration-none text-subtitle-2 font-weight-bold"
        @click.prevent="returnBack"
      >
        <v-icon
          color="primary"
          dense
          class="mr-2"
        >
          {{ icons.mdiArrowLeft }}
        </v-icon>
        Kembali
      </a>
    </div>
    <MainCard>
      <template v-slot:body>
        <DataTablePagination
          title="Guru Paling Aktif"
          subtitle="Daftar guru paling aktif"
          :no-add-button="noAddButton"
          :headers="headers"
          :items="teachers"
          :search="search"
          :page="page"
          :total-items="totalItems"
          :total-pages.sync="totalPages"
          :is-loading="isLoadingData"
          @live-search="searchHandler"
          @change-page="paginationHandler"
        ></DataTablePagination>
      </template>
    </MainCard>
  </div>
</template>

<script>
import DataTablePagination from '@/views/components/DataTablePagination.vue'
import MainCard from '@/views/components/MainCard.vue'
import { mdiArrowLeft } from '@mdi/js'

export default {
  name: 'BookPurchaseHistory',
  components: {
    MainCard,
    DataTablePagination,
  },
  data() {
    return {
      noAddButton: true,
      icons: { mdiArrowLeft },
      headers: [
        { text: 'No', value: 'index' },
        { text: 'Nama', value: 'photo-user' },
        { text: 'Asal Sekolah', value: 'school' },
        { text: 'Aktifitas', value: 'activity' },
        { text: 'E-Learning', value: 'elearning' },
        { text: 'Bank Soal', value: 'question_bank' },
      ],
      teachers: [],
      page: 1,
      search: '',
      service: 'teacher',
      totalItems: 10,
      totalPages: 0,
      isLoadingData: false,
      filterQuery: {
        search: '',
      },
      school_uuid: '',
    }
  },
  watch: {
    page: {
      handler() {
        this.listActiveTeacher()
      },
    },
    search: {
      handler() {
        this.listActiveTeacher()
      },
    },
  },
  async mounted() {
    await this.getSchoolUuid()
    await this.listActiveTeacher()
  },
  methods: {
    getSchoolUuid() {
      this.school_uuid = this.$route.params.uuid
    },
    async listActiveTeacher(params = {}) {
      this.isLoadingData = true
      await this.$services.ApiServices.list(this.service, {
        ...params,
        page: this.page,
        school_uuid: this.school_uuid,
      }).then(({ data }) => {
        this.teachers = data.data.map((teacher, index) => ({
          ...teacher,
          index: index + 1,
        }))
        this.totalItems = data.meta.total
        this.totalPages = data.meta.last_page
      })
      this.isLoadingData = false
      this.isLoadingTable = false
    },
    async searchHandler(search) {
      this.filterQuery.search = search
      this.page = 1
      await this.listActiveTeacher(this.filterQuery)
    },
    paginationHandler(pageNumber) {
      this.page = pageNumber
    },
    returnBack() {
      this.$router.back()
    },
  },
}
</script>

<style>
</style>
